import React from 'react';
import Grid from '../Grid';
import Heading from '../Heading';
import styles from './Highlights.module.scss';
export const Highlights = ({ title, titleLevel = 3, description, items = [], CustomImage, }) => (<Grid.Container>
    <Grid.Row justify='center'>
      <Grid.Col xs={12} md={4} lg={5}>
        {title && (<Heading level={titleLevel} scale={2} className={styles.highlightsTitle}>
            {title}
          </Heading>)}
        {description && (<div className={styles.highlightsDescription} dangerouslySetInnerHTML={{ __html: description }}/>)}
      </Grid.Col>
      <Grid.Col>
        <Grid.Row>
          {items.map(({ title: highlightTitle, image }) => (<div key={`${image.id}:${highlightTitle}`} className={styles.highlightsItem}>
              {!!image && <CustomImage className={styles.highlightsItemImage} image={image}/>}
              <p className={styles.highlightsItemTitle}>{highlightTitle}</p>
            </div>))}
        </Grid.Row>
      </Grid.Col>
    </Grid.Row>
  </Grid.Container>);
